import { useEffect, useState } from "react";
import { getStudentCourseData } from "../../services/dashboardService";
import CourseItem from "../../components/dashboard/CourseItem";
import { useSelector } from "react-redux";

export default function StudentCourse() {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const token: string = useSelector((state: any) => state.auth.token);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      const resData: any = await getStudentCourseData(token);
      setData(resData?.data);
      setLoading(false)
    };
    fetchData();
  }, [token]);

  const renderCourses = (courses: any[]) => {
    if(loading){
      return <div className="mx-auto mb-2">Loading...</div>;
    }
    if (!courses || courses.length === 0) {
      return <div className="mx-auto mb-2">No data found</div>;
    }

    return courses.map((course: any) => (
      <CourseItem
        key={course.id}
        title={course.title}
        imageUrl={course.featuredImage}
        instructor={course.instructor}
        rating={Math.round(course.averageRating)}
        progress={course.progress}
        lessonsCount={course.lessonsCount}
        duration={course.courseDuration}
        category={course.category}
        courseLink={`/creative-warriors-course-detail/${course?.id}`}
        instructorLink={course.instructorLink}
      />
    ));
  };

  return (
    <div className="col-lg-9">
      <div className="dashboard__content-wrap dashboard__content-wrap-two">
        <div className="dashboard__content-title">
          <h4 className="title">Enrolled Courses</h4>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="dashboard__nav-wrap">
              <ul className="nav nav-tabs" id="courseTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="all-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#enrolled-courses-tab-pane"
                    type="button"
                    role="tab"
                    aria-controls="enrolled-courses-tab-pane"
                    aria-selected="true"
                  >
                    Enrolled Courses
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="design-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#design-tab-pane"
                    type="button"
                    role="tab"
                    aria-controls="design-tab-pane"
                    aria-selected="false"
                  >
                    Active Courses
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="business-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#business-tab-pane"
                    type="button"
                    role="tab"
                    aria-controls="business-tab-pane"
                    aria-selected="false"
                  >
                    Completed Courses
                  </button>
                </li>
              </ul>
            </div>
            <div className="tab-content" id="courseTabContent">
              <div
                className="tab-pane fade show active"
                id="enrolled-courses-tab-pane"
                role="tabpanel"
                aria-labelledby="enrolled-courses-tab-pane"
                tabIndex={0}
              >
                <div className="row row-cols-1 row-cols-xl-3 row-cols-lg-2 row-cols-md-2 row-cols-sm-1">
                  {renderCourses(data?.courseEnrolled)}
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="design-tab-pane"
                role="tabpanel"
                aria-labelledby="design-tab"
                tabIndex={0}
              >
                <div className="">
                  <div className="row row-cols-1 row-cols-xl-3 row-cols-lg-2 row-cols-md-2 row-cols-sm-1">
                    {renderCourses(data?.courseActive)}
                  </div>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="business-tab-pane"
                role="tabpanel"
                aria-labelledby="business-tab"
                tabIndex={0}
              >
                <div className="">
                  <div className="row row-cols-1 row-cols-xl-3 row-cols-lg-2 row-cols-md-2 row-cols-sm-1">
                    {renderCourses(data?.courseCompleted)}{" "}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
